import { supabase } from "@supabaseClient/supabaseClient";

export interface IOrganizationSetting {
  id: string;
  organization_id: string;
  setting_key: string;
  setting_value: Record<string, string | number | boolean | null | undefined>;
  created_at: string;
  updated_at: string;
}

export class OrganizationSettingsClient {
  static async getSetting(
    organization_id: string,
    setting_key: string
  ): Promise<IOrganizationSetting | null> {
    const { data, error } = await supabase
      .from("organization_settings")
      .select("*")
      .eq("organization_id", organization_id)
      .eq("setting_key", setting_key)
      .single();

    if (error) {
      if (error.code === "PGRST116") {
        // No rows returned
        return null;
      }
      throw error;
    }
    return data;
  }

  static async setSetting(
    organization_id: string,
    setting_key: string,
    setting_value: Record<string, string | number | boolean | null | undefined>
  ): Promise<IOrganizationSetting> {
    const { data, error } = await supabase
      .from("organization_settings")
      .upsert(
        {
          organization_id,
          setting_key,
          setting_value,
          updated_at: new Date().toISOString(),
        },
        {
          onConflict: "organization_id,setting_key",
        }
      )
      .select()
      .single();

    if (error) {
      throw error;
    }
    return data;
  }

  static async deleteSetting(
    organization_id: string,
    setting_key: string
  ): Promise<void> {
    const { error } = await supabase
      .from("organization_settings")
      .delete()
      .eq("organization_id", organization_id)
      .eq("setting_key", setting_key);

    if (error) {
      throw error;
    }
  }
}
